var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.379 24.913C27.867 23.635 27 21.767 27 19.788V17C27 13.481 24.386 10.568 21 10.08V9C21 8.447 20.552 8 20 8C19.448 8 19 8.447 19 9V10.08C15.613 10.568 13 13.481 13 17V19.788C13 21.767 12.133 23.635 10.612 24.921C10.223 25.254 10 25.738 10 26.25C10 27.215 10.785 28 11.75 28H28.25C29.215 28 30 27.215 30 26.25C30 25.738 29.777 25.254 29.379 24.913Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eacb4eea57fb2c1eddcf7073b6944ea4.svg";
export { ForwardRef as ReactComponent };